<template>
    <div class="power-range-list">
        <v-tag
            v-for="(item, index) of list"
            :key="item.id"
            use-default-suf-icon
            size="large"
            :pre-icon="item.type === 0 ? 'basic_file_line' : 'basic_me_line'"
            icon-fixed
            :text="item.name"
            class="power-range-list-item"
            @sufAction="handleDelete(index, list)"
        />
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    methods: {
        handleDelete(index, parent) {
            this.$emit('onDelete', {
                index,
                parent,
            });
        },
    },
};
</script>

<style lang="less">
.power-range-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    &-item {
        margin-bottom:  var(--spacing-super-tight);
        margin-right: var(--spacing-super-tight);
    }
}
</style>
